import { render } from "./GraphicsDesign.vue?vue&type=template&id=5d1391f6"
import script from "./GraphicsDesign.vue?vue&type=script&lang=js"
export * from "./GraphicsDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__